// extracted by mini-css-extract-plugin
module.exports = {"item":"SelectorItem__item--2ryIo","link":"SelectorItem__link--1rLpQ"};